import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { logout } from "../../actions/admin/auth";
import { getData } from "../../actions/admin/index";
import { showConfirm } from "../../actions/message";
import logo from "../../assets/images/logo/black.png";
import logoMark from "../../assets/images/logo/icon.png";
import { Path, PathGenerator } from "../../constants/path";
import { Link } from "../util/Clickable";

class AdminHeader extends Component {
  componentWillMount = () => {
    this.redirectIfNotAuthed(this.props);
    if (this.props.auth.role == "admin") {
      this.props.actions
        .getData()
        .then(({ value, action }) => {
          if (value.status > 400) {
            this.doLogout();
          }
        })
        .catch((error) => console.log(error));
    }
  };

  componentWillReceiveProps = (nextProps) => {
    this.redirectIfNotAuthed(nextProps);
  };

  redirectIfNotAuthed = (props) => {
    if (props.history.location.pathname.match(/\/admin\/auth\/[\w]*/)) {
      if (props.auth.role == "admin") {
        props.history.push(PathGenerator.getLocalPath(Path.admin.top.url));
      }
    } else {
      if (props.auth.role != "admin") {
        props.history.push(
          PathGenerator.getLocalPath(Path.admin.auth.login.url),
        );
      }
    }
  };

  logout = () => {
    this.props.actions.showConfirm("Sign Out", null, (confirmed) => {
      if (confirmed) {
        this.doLogout();
      }
    });
  };

  doLogout = () => {
    this.props.actions
      .logout()
      .then(({ value, action }) => {
        if (value.status < 300) {
          this.props.history.push(
            PathGenerator.getLocalPath(Path.admin.auth.login.url),
          );
        }
      })
      .catch((error) => console.log(error));
  };

  render = () => {
    return (
      <div>
        <div
          {...{
            "uk-sticky": "sel-target: > div; cls-active: uk-navbar-sticky",
          }}
        >
          <div className="uk-background-white uk-box-shadow-small">
            <header className="uk-padding@s uk-padding-small uk-padding-remove-vertical">
              <nav
                className="uk-navbar-container uk-background-white"
                {...{ "uk-navbar": "" }}
              >
                <div className="uk-navbar-left uk-position-relative">
                  <div className="uk-navbar-item uk-padding-remove">
                    <Link
                      className="uk-link-reset uk-margin-small-right"
                      to={Path.admin.top.url}
                    >
                      <img src={logo} className="uk-width-logo uk-visible@s" />
                      <img
                        src={logoMark}
                        className="uk-height-ssmall uk-hidden@s"
                      />
                    </Link>
                    <span className="uk-margin-remove uk-h4 uk-text-mincho">
                      For Admin
                    </span>
                  </div>
                </div>
                {(() => {
                  if (this.props.auth.role == "admin") {
                    return (
                      <div className="uk-navbar-right uk-visible@m">
                        <div className="uk-navbar-item">
                          <Link
                            className="uk-button uk-button-text"
                            to={Path.admin.top.url}
                          >
                            {this.props.auth.data.email}
                          </Link>
                        </div>
                        <div className="uk-navbar-item uk-padding-remove">
                          <Link
                            className="uk-button uk-button-text"
                            onClick={this.logout}
                          >
                            Sign Out
                          </Link>
                        </div>
                      </div>
                    );
                  }
                })()}
                {(() => {
                  if (this.props.auth.role == "admin") {
                    return (
                      <div className="uk-navbar-right uk-hidden@m">
                        <a
                          className="uk-navbar-toggle"
                          {...{ "uk-toggle": "target: #admin-menu" }}
                        >
                          <span {...{ "uk-navbar-toggle-icon": "" }}></span>
                        </a>
                      </div>
                    );
                  }
                })()}
              </nav>
            </header>
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      logout: () => dispatch(logout()),
      getData: () => dispatch(getData()),
      showConfirm: (...data) => dispatch(showConfirm(...data)),
    },
    dispatch,
  ),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AdminHeader),
);
